export default __webpack_public_path__ + "static/media/biobankki-footer-logos.b6314be8.png";